import { render, staticRenderFns } from "./PDLList.vue?vue&type=template&id=1a24d63c&"
import script from "./PDLList.vue?vue&type=script&lang=js&"
export * from "./PDLList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports